<template>
    <div class="alert-container mt-2">
        <div class="fade-in-out alert alert-error" >
            <div><strong>{{errorMessage}}</strong></div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: "alert-message",
        computed: {
            ...mapGetters(["isLoading", "errorMessage"])

        }
    }
</script>

<style scoped>

</style>